<section class="blog-list content-wrapper">
  <h1 class="title">Insights That Drive Digital Success</h1>
  <p class="mb-4">
    Welcome to the Geekeno Blog — your hub for actionable insights in digital
    marketing, SEO, branding, and content strategy. Whether you're a local
    business in Goa or scaling globally, our articles, case studies, and expert
    guides are here to help you grow smarter, rank higher, and connect deeper
    with your audience.
  </p>
  <app-blog-list [blogs]="blogs()" />
  @if (loading()) {
    <p class="has-text-centered">Loading more blogs...</p>
  }
  @if (!loading() && error() && !blogs().length) {
    <div class="has-text-centered">
      <p>Something seems to have gone wrong while fetching the blog posts.</p>
      <p>Please try again in some time.</p>
    </div>
  }
</section>
